package co.uk.sacursoftware.ssinventory.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

actual class PlatformImagePicker(
    private val onGallery: () -> Unit,
    private val onCamera: () -> Unit
) {
    actual fun pickFromGallery() = onGallery()
    actual fun takePhoto() = onCamera()
}

@Composable
actual fun rememberPlatformImagePicker(
    onImagePicked: (ByteArray, String) -> Unit
): PlatformImagePicker {
    return remember {
        val pickerHandler = { capture: Boolean ->
            val input = document.createElement("input") as HTMLInputElement
            input.type = "file"
            input.accept = "image/*"
            if (capture) {
                input.setAttribute("capture", "environment")
            }
            input.onchange = { _ ->
                val files = input.files
                if (files != null && files.length > 0) {
                    val file = files.item(0)
                    if (file != null) {
                        val reader = FileReader()
                        reader.onload = { _ ->
                            val arrayBuffer = reader.result
                            val uint8Array = js("new Uint8Array(arrayBuffer)") as org.khronos.webgl.Uint8Array
                            val byteArray = ByteArray(uint8Array.length)
                            for (i in 0 until uint8Array.length) {
                                byteArray[i] = uint8Array.asDynamic()[i] as Byte
                            }
                            onImagePicked(byteArray, file.name)
                            null
                        }
                        reader.readAsArrayBuffer(file)
                    }
                }
                null
            }
            input.click()
        }

        PlatformImagePicker(
            onGallery = { pickerHandler(false) },
            onCamera = { pickerHandler(true) }
        )
    }
}
